import { DataTableCellV2, DataTableRowV2 } from '@americanexpress/dls-react';
import React from 'react';
import PropTypes from 'prop-types';
import * as LABELCONST from '../constants/constFileLabelsVendor';
//TODO: Replace <> with proper div and css

const LocalAddressData = (props) => {
  const { localData } = props;
  return (
    <>
      <DataTableRowV2>
        <DataTableCellV2>{LABELCONST.SUPPLIER_REGISTERED_LOCAL_NAME}</DataTableCellV2>
        <DataTableCellV2>{localData?.supplierRegisteredLocalName}</DataTableCellV2>
      </DataTableRowV2>
      <DataTableRowV2>
        <DataTableCellV2>{LABELCONST.PAYEE_LOCAL_NAME}</DataTableCellV2>
        <DataTableCellV2>{localData?.payeeLocalName}</DataTableCellV2>
      </DataTableRowV2>
      <DataTableRowV2>
        <DataTableCellV2>
          {LABELCONST.SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE1}
        </DataTableCellV2>
        <DataTableCellV2>{localData?.supplierRegisteredLocalAddress_Line1}</DataTableCellV2>
      </DataTableRowV2>
      <DataTableRowV2>
        <DataTableCellV2>
          {LABELCONST.SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE2}
        </DataTableCellV2>
        <DataTableCellV2>{localData?.supplierRegisteredLocalAddress_Line2}</DataTableCellV2>
      </DataTableRowV2>
      <DataTableRowV2>
        <DataTableCellV2>
          {LABELCONST.PAYEE_ADDRESS_LOCAL_LINE1}
        </DataTableCellV2>
        <DataTableCellV2>{localData?.payeeLocalAddress_Line1}</DataTableCellV2>
      </DataTableRowV2>
      <DataTableRowV2>
        <DataTableCellV2>
          {LABELCONST.PAYEE_ADDRESS_LOCAL_LINE2}
        </DataTableCellV2>
        <DataTableCellV2>{localData?.payeeLocalAddress_Line2}</DataTableCellV2>
      </DataTableRowV2>
    </>
  );
};

LocalAddressData.propTypes = {
  localData: PropTypes.func,
};

export default LocalAddressData;
